import { useTranslation } from 'next-i18next/pages';

import { TRANSLATION_NAMESPACE } from '@/i18n/config';
import { useUserData } from '@/hooks/useUserData';

import { TextInput } from '../../TextInput/TextInput';

export const LastNameInput = () => {
  const { userData, isSignedInAndUserDataNotLoaded } = useUserData();
  const { t } = useTranslation(TRANSLATION_NAMESPACE.property_expose);

  if (isSignedInAndUserDataNotLoaded) return null;

  return (
    <TextInput
      label={t('search.contact.form.label.lastName')}
      name="lastName"
      defaultValue={userData?.lastName}
      type="text"
      autoComplete="family-name"
      isRequired
      validationMessages={{
        valueMissing: t('search.contact.form.validation.lastName.required'),
      }}
    />
  );
};
